const closeDocument = () => {
    const pdf = window.PDFViewerApplication
    if (pdf) {
        const close = pdf.close
        return close.bind(pdf)
    }
}

export default closeDocument